const access = {
  entities: [
    { label: 't(Panels)', code: 'panels' }
  ], 
  rights: [] 
}

export default access
